import css from '@emotion/css';

export const motiveLogoStyle = css`
    width: 300px;
    text-align: center;
    & > img {
        width: 100%;
    }
`;
